import { Switch, Route } from 'react-router-dom'
import MeltingSeason from './pages/MeltingSeason'
import ClosedEyeVisual from './pages/ClosedEyeVisual'
import VideoPage from './pages/VideoPage'

const baseRoutes = [
  { path: '/', comp: MeltingSeason, exact: true },
  { path: '/closed-eye-visual/:video_id', comp: VideoPage, exact: true },
  { path: '/closed-eye-visual', comp: ClosedEyeVisual, exact: false },
]

export default function Routes() {
  return (
    <Switch>
      { baseRoutes.map( option => 
        <Route
          exact={ option.exact }
          path={ option.path }
          key={ option.path }
          component={ option.comp } />
      ) }
    </Switch>
  )
}